<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="RkmModal"
        title="Detalhamento do agendamento"
    >
        <rkm-alert show info v-if="paciente">
            <strong>Paciente:</strong>

            {{ paciente.nome }}

            <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                ({{ paciente.nomeSocial }})
            </strong> -

            <strong>Idade:</strong>
                    <template v-if="paciente.idade">
                        {{ paciente.anos }} anos,
                        {{ paciente.meses }} meses e
                        {{ paciente.dias }} dias
                    </template>
                    <template v-else>
                        -
                    </template> -
                <strong>Prontuário: </strong>{{ paciente.prontuario }}
        </rkm-alert>

        <rkm-row v-if="paciente">
            <rkm-col>
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <td><strong>Agendamento:</strong></td>
                            <td>{{ agendamento.agendamentoNumero }}</td>
                        </tr>
                        <tr>
                            <td><strong>Data do agendamento:</strong></td>
                            <td>{{agendamento.data}} às {{agendamento.horaInicial}}</td>
                        </tr>
                        <tr>
                            <td><strong>Agendamento urgente:</strong></td>
                            <td>{{ agendamento.urgente ? 'Sim' : 'Não' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Exame(s) agendado(s):</strong></td>
                            <td> {{examesIncluido()}} </td>
                        </tr>
                        <tr v-if="paciente.anos < 18">
                            <td><strong>Responsável:</strong></td>
                            <td>{{agendamento.responsavel}}</td>
                        </tr>
                        <tr>
                            <td><strong>Médico solicitante:</strong> </td>
                            <td>{{agendamento.medicoNome}}</td>
                        </tr>
                        <tr v-if="paciente.sexoId == this.enums.sexo.FEMININO">
                            <td><strong>Data da última menstruação:</strong> </td>
                            <td>{{agendamento.dataMenstruacao}}</td>
                        </tr>
                        <tr v-if="paciente.sexoId == this.enums.sexo.FEMININO">
                            <td><strong>Gestante:</strong> </td>
                            <td>
                                <span v-if="agendamento.gestante">Sim</span>
                                <span v-else>Não</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Unidade solicitante:</strong> </td>
                            <td>{{agendamento.unidadeNome}} - {{agendamento.infraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Laboratório:</strong></td>
                            <td>{{agendamento.laboratorioNome}} - {{agendamento.laboratorioInfraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Local de coleta:</strong></td>
                            <td>{{agendamento.coletaNome}} - {{agendamento.coletaInfraestruturaNome}}</td>
                        </tr>
                        <tr v-if="agendamento.integracaoAtiva">
                            <td><strong>Status da integração:</strong></td>
                            <td>
                                {{ agendamento.statusIntegracao }}
                                <span v-if="agendamento.statusIntegracaoDataHora">
                                    (Atualizado em {{ agendamento.statusIntegracaoDataHora }})
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Uso de medicamento:</strong></td>
                            <td>{{agendamento.medicamentos}}</td>
                        </tr>
                        <tr>
                            <td><strong>Suspeita clínica:</strong></td>
                            <td>{{agendamento.suspeita}}</td>
                        </tr>
                        <tr>
                            <td><strong>Observação:</strong></td>
                            <td>{{agendamento.observacao}}</td>
                        </tr>
                    </tbody>
                </table>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'

export default {
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }
    },
    data: () => ({
        agendamento: {
            data: null,
            exameId: null,
            exameNome: '',
            horaInicial: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            unidadeNome: '',
            observacao: '',
            incluido: [],
            urgente: null,
            integracaoAtiva: false,
            statusIntegracao: null,
            statusIntegracaoDataHora: null,
        },
        enums: {
            preferenciaNome,
            sexo,
            diasSemana,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        examesIncluido(){

            let nomeExames = ''

            if (this.agendamento.incluido) {

                this.agendamento.incluido.forEach(exameNomeIncluido => {

                    if(!nomeExames){

                        nomeExames = exameNomeIncluido.nome
                    } else {

                        nomeExames = nomeExames + ', ' + exameNomeIncluido.nome
                    }
                })
            }

            return nomeExames
        },
        open(agendamentoId) {

            this.setLoading()

            this.repositories.agendamento.getDetalhamento(agendamentoId)
                .then(({ data }) => {

                    this.loadAgendamento(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadAgendamento(item) {

            var data = moment(item.data, 'DD/MM/YYYY').toDate()
            var dia = data.getDay() + 1;

            this.agendamento.diasSemana = this.getStringDiaSemana(dia)

            this.agendamento.agendamentoNumero = item.agendamentoNumero
            this.agendamento.unidadeNome = item.unidadeNome
            this.agendamento.infraestruturaNome = item.infraestruturaNome
            this.agendamento.medicoNome = item.medicoNome
            this.agendamento.dataMenstruacao = item.dataMenstruacao
                ? moment(item.dataMenstruacao).format('DD/MM/YYYY') : 'Não informado'
            this.agendamento.gestante = item.gestante
            this.agendamento.responsavel = item.responsavel
            this.agendamento.data = item.data.split("-").reverse().join("/")
            this.agendamento.horaInicial = item.horaInicial
            this.agendamento.medicamentos = item.medicamentos ?? 'Não informado'
            this.agendamento.suspeita = item.suspeita ?? 'Não informada'
            this.agendamento.observacao = item.observacao ?? 'Não informada'
            this.agendamento.coletaNome = item.coletaNome
            this.agendamento.coletaInfraestruturaNome = item.coletaInfraestruturaNome
            this.agendamento.incluido = item.incluido
            this.agendamento.urgente = item.urgente
            this.agendamento.integracaoAtiva = item.integracaoAtiva
            this.agendamento.statusIntegracao = item.statusIntegracao
            this.agendamento.statusIntegracaoDataHora = item.statusIntegracaoDataHora

            this.agendamento.laboratorioNome = item.laboratorioNome
            this.agendamento.laboratorioInfraestruturaNome = item.laboratorioInfraestruturaNome

            this.$refs.RkmModal.show()
        },
        getStringDiaSemana(dia) {

            if(dia == this.enums.diasSemana.DOMINGO){

               return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA){

               return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA){

               return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA){

               return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA){

               return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA){

               return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO){

               return 'SÁBADO'
            }
        },
    },
    mixins: [ error, repository ],
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true},
    },
}
</script>

